import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import Loader from "../../../Components/MainLayout/Loader";
import Header from "../../../Components/MainLayout/Header";
import Authorize from "../../../../global/Authorize";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class ClassSMS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Complaint: [],
      classs: [],
      section: [],
      checkedclass: [],
      checkedsection: [],
      formData: {
        school: "",
        name: "",
        phone_no: "",
        complain: "",
      },
      loading: false,
      success: false,
      alertMessage: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Group Sms";
    this.fetchclass();
    this.fetchsection();
  }

  fetchclass = () => {
    this.setState({ loading: true });
    axios.get(`/api/class`, {}).then((res) => {
      this.setState({
        classs: res.data,
      });
    });
  };
  fetchsection = () => {
    axios.get(`/api/section`, {}).then((res) => {
      this.setState({
        loading: false,
        section: res.data,
      });
    });
  };

  handleClick = () => {
    this.setState({ loading: true });
  };

  handleCheckbox = (event) => {
    var arr = this.state.checkedclass;
    if (this.state.checkedclass.includes(event.target.value)) {
    } else {
      arr.push(event.target.value);
    }
    this.setState({ checkedclass: arr });
  };
  handleCheckbox1 = (event) => {
    var arr = this.state.checkedsection;
    if (this.state.checkedsection.includes(event.target.value)) {
    } else {
      arr.push(event.target.value);
    }
    this.setState({ checkedsection: arr });
  };

  handleChange = (event) => {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({ formData });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let form_data = new FormData();
    const { formData } = this.state;
    // var
    form_data.append("school", this.props.user.user.school.id);
    form_data.append("session", this.props.user.session.id);
    form_data.append("message", formData.message);
    for (var i = 0; i < this.state.checkedclass.length; i++) {
      form_data.append("class", this.state.checkedclass[i]);
    }
    for (var j = 0; j < this.state.checkedsection.length; j++) {
      form_data.append("section", this.state.checkedsection[j]);
    }
    // form_data.append("roles", JSON.stringify(this.state.checkedroles))
    if (this.state.formData.message) {
      axios
        .post(`/api/csendSMS`, form_data)
        .then((response) => {
          this.setState({ loading: false, success: true });
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false, alertMessage: true });
    }
  };

  render() {
    const { formData } = this.state;
    const classdata = this.state.classs?.map((item) => (
      <div className="input-group in-line align-items-center pb-3">
        <input
          type="checkbox"
          onChange={this.handleCheckbox}
          name="checkecollectfee"
          color="primary"
          value={item.id}
        />
        <div className="th-12 th-cap pl-2">{item.class_name}</div>
      </div>
    ));
    const sectiondata = this.state.section?.map((item) => (
      <div className="input-group in-line align-items-center pb-3">
        <input
          type="checkbox"
          onChange={this.handleCheckbox1}
          name="checkecollectfee"
          color="primary"
          value={item.id}
        />
        <div className="th-12 th-cap pl-2">{item.section_name}</div>
      </div>
    ));
    return (
      <Authorize
        roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <div>
          <Header to="/home" title="Class SMS" />

          <div className="d-flex flex-row th-no-scroll pt-2">
            <Link style={{ textDecoration: "none" }} to="/grpsms">
              <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
                <div className="th-black">Group SMS</div>
              </div>
            </Link>
            <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
              <div className="th-primary">Class SMS</div>
              <hr
                className="w-100 my-1 th-border"
                style={{ borderWidth: 5, borderRadius: 5 }}
              />
            </div>
          </div>

          <div className="container">
            <div className="rounded">
              <form onSubmit={this.handleSubmit} autoComplete="off">
                <div className="input-group input-group shadow-sm">
                  <textarea
                    className="form-control th-input-primary"
                    placeholder="Message"
                    style={{ minHeight: 200 }}
                    name="message"
                    value={formData.message}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="th-14 th-medium th-black mt-3 mb-2">
                      Class:
                    </div>
                    {classdata}
                  </div>
                  <div className="col-6">
                    <div className="th-14 th-medium th-black mt-3 mb-2">
                      Section:
                    </div>
                    {sectiondata}
                  </div>
                </div>

                {this.state.success && (
                  <div className="th-14 th-medium th-black mt-3 mb-2 text-center">
                    Message Send Successfully
                  </div>
                )}
                {this.state.alertMessage && (
                  <div className="th-14 th-medium th-black mt-3 mb-2 text-center">
                    Message Not Send Successfully
                  </div>
                )}
                <div className="d-flex justify-content-end py-3">
                  {this.state.loading ? (
                    <div className="my-1 pr-2">
                      <Loader />
                    </div>
                  ) : null}
                  <button
                    onClick={this.handleClick}
                    type="submit"
                    className="th-btn-primary px-4 py-2"
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Authorize>
    );
  }
}
export default withRouter(connect(mapStateToProps)(ClassSMS));
